<template>
	<div class="search">
		<div class="icon" v-html="require('@/assets/icons/search-regular.svg')"/>
		<input v-bind="{placeholder}" v-model="input" @keyup="update(input)"/>
	</div>
</template>

<script>
import {debounce} from "lodash";

export default {
	data() {
		return {
			input: this.$route.query.search
		}
	},
	computed: {
		placeholder() {
			return this.$res.small() ? "produktnavn eller sku" : "Søg på produktnavn eller sku";
		}
	},
	methods: {
		update: debounce(function(input) {
			this.$emit("update", {query: {search: input || undefined}});
		}, 500)
	}
};
</script>

<style lang="scss" scoped>
.search {
	display: flex;
	align-items: center;

	.icon {
		display: inline-flex;
		margin-right: 9px;

		/deep/ svg {
			$s: 14px;
			width: $s;
			height: $s;
			path {
				fill: #B3B9BF;
			}
		}
	}

	input {
		font-size: 14px;
		width: 260px;
		outline: 0;
		apperance: none;
		border: 0px;

		@include res(small) {
			width: 140px;
		}

		@include placeholder {
			color: #B3B9BF;
		};
	}
}
</style>
